import { CmsReactComponent } from 'components/cms/CmsReactComponent';
import {
    EntryOptions,
    PropertyDefinition
} from "app/library/layout-builder";
import { PageTitleProps } from "./types";
import { MetaTypeEnum } from "app/shared";
import { PageTitlePropertyDefinitions } from 'components/cms/definitions';

export class PageTitleDefinitions extends CmsReactComponent<PageTitleProps> {
    static defaultProps = {};

    static schemaName = "page-title";

    static propertyDefinitions: PropertyDefinition[] = PageTitlePropertyDefinitions;

    static options: EntryOptions = {
        meta: {
            use: true,
            allowedTypes: [
                MetaTypeEnum.Text,
                MetaTypeEnum.TextArea,
                MetaTypeEnum.SingleImage,
                MetaTypeEnum.Editor,
                MetaTypeEnum.Date,
                MetaTypeEnum.Dropdown,
            ],
        },
    };

}
